<tile
    title="{{ 'total_keywords_improved' | translate }}"
    icon="chart-line"
    val="{{ totalKeywordsImproved | undefinedNumber }}"
    help ="{{ 'total_keywords_improved_help' | translate }}">
</tile>
